export default "__VITE_ASSET__eBobtOfH__"